import EventBusyIcon from "@mui/icons-material/EventBusy";

import LeaveCalendarPage from "./LeaveCalendarPage";

export default {
  list: LeaveCalendarPage,
  icon: EventBusyIcon,
  label: "Leave calendar",
  options: { label: "Leave calendar" },
  name: "leaveCalendar",
};
